import { useState } from "react";
import { useNavigate,Link } from "react-router-dom";

function DashboardTabs({ onTabChange,name }) {
  const [activeTab, setActiveTab] = useState(name);
   const navigate = useNavigate();

  const handleTabChange = (tab) => {
    setActiveTab(tab);

      if (tab === "visits") {
      // Load visits

      navigate('/doctor-dashboard');
    }

    if (tab === "conference") {
      // Load conference
      navigate('/doctor-vqueue');
    }
    if (tab === "bookapt") {
      // Load conference
      navigate('/request-appointment');
    }
     if (tab === "vinvite") {
      // Load conference
      navigate('/doctor-vedio');
    }

    //onTabChange(tab);
  };

  return (
    <ul className="nav custom-tabs">
      <li className="nav-item" style={{ borderBottom: `${activeTab === "visits" ? "3px solid #0f4c81" : "none"}` }}>
        <button
          className={`nav-link ${activeTab === "visits" ? "" : ""}`}
          onClick={() => handleTabChange("visits")}
        >
          Visits
        </button>
      </li>

      <li className="nav-item" style={{ borderBottom: `${activeTab === "conference" ? "3px solid #0f4c81" : "none"}` }}>
        <button
          className={`nav-link ${
            activeTab === "conference" ? "" : ""
          }`}
          onClick={() => handleTabChange("conference")}
        >
          Vitrual
        </button>
      </li>

      

       <li className="nav-item" style={{ borderBottom: `${activeTab === "vinvite" ? "3px solid #0f4c81" : "none"}` }}>
        <button
          className={`nav-link ${
            activeTab === "vinvite" ? "" : ""
          }`}
          onClick={() => handleTabChange("vinvite")}
        >
          Invite
        </button>
      </li>

       <li className="nav-item" style={{ borderBottom: `${activeTab === "bookapt" ? "3px solid #0f4c81" : "none"}` }}>
        <button
          className={`nav-link ${
            activeTab === "bookapt" ? "" : ""
          }`}
          onClick={() => handleTabChange("bookapt")}
        >
          Book Appointment
        </button>
      </li>
    </ul>
  );
}
export default DashboardTabs;
